export const useGetTokenFromParams = () => {
    const queryParams = new URLSearchParams(window.location.search); //todo: check this solution
    const tokenFromQuery = queryParams.get("lumitoken");

    return {
        isTokenExist: !!tokenFromQuery,
        tokenFromQuery,
    };
};
